import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getOptionFromValue, getOptionFromValueTimePeriod} from '../../PlanTemplates/ACC/benefitDefaults';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const BrokenTooth = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex ?? 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'broken-tooth-row-1'},
      items: [
        {
          key:propertyPaths.brokenToothDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.brokenToothDetails.incurralPeriod)}
              disabled
              required
              id={propertyPaths.brokenToothDetails.incurralPeriod}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.brokenToothDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.brokenToothDetails.customizeBenefitAmount)}
              disabled
              id={propertyPaths.brokenToothDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'broken-tooth-row-2'},
      items: [
        {
          key: propertyPaths.brokenToothDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(getQuoteFieldValue<number>(propertyPaths.brokenToothDetails.benefitAmount))}
              disabled
              required
              adornment="money"
              id={propertyPaths.brokenToothDetails.benefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.brokenToothDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Number of Times Benefit is Payable per Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.brokenToothDetails.maxBenefitNumber)}
              options={getOptionFromValue(
                getQuoteFieldValue<string>(propertyPaths.brokenToothDetails.maxBenefitNumber) ?? ''
              )}
              disabled
              required
              id={propertyPaths.brokenToothDetails.maxBenefitNumber}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'broken-tooth-row-3'},
      items: [
        {
          key: propertyPaths.brokenToothDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Time Period"
              value={getQuoteFieldValue<string>(propertyPaths.brokenToothDetails.timePeriodCd)}
              options={getOptionFromValueTimePeriod(
                getQuoteFieldValue<string>(propertyPaths.brokenToothDetails.timePeriodCd) ?? ''
              )}
              id={propertyPaths.brokenToothDetails.timePeriodCd}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
